import { Clock } from "lucide-react";

interface KioskActivityPromptProps {
  isVisible: boolean;
  onConfirm: () => void;
  remainingSeconds: number;
}

export const KioskActivityPrompt = ({
  isVisible,
  onConfirm,
  remainingSeconds
}: KioskActivityPromptProps) => {
  if (!isVisible) return null;

  return (
    <div className="kiosk-prompt-overlay" onClick={(e) => e.stopPropagation()}>
      <div className="kiosk-prompt-box">
        <Clock className="kiosk-prompt-icon" size={64} />
        <h2 className="kiosk-prompt-title">¿Sigues aquí?</h2>
        <p className="kiosk-prompt-countdown">
          {remainingSeconds} segundo{remainingSeconds !== 1 ? 's' : ''} restante{remainingSeconds !== 1 ? 's' : ''}
        </p>
        <button 
          className="kiosk-prompt-button"
          onClick={onConfirm}
          type="button"
        >
          Sí, estoy aquí
        </button>
      </div>
    </div>
  );
};
